const GROUP_STATUS = {
  CAN_JOIN_GROUP                             : 1,
  STUDENT_SUBSCRIBED_IN_GROUP                : 2,
  GROUP_FULL                                 : 3,
  REGISTRATION_EXPIRED                       : 4,
  GROUP_HAS_CORRECTION                       : 5,
  STUDENT_ANSWERED_ACTIVITY_BY_ANOTHER_GROUP : 6,
  MY_GROUP_HAS_ANSWER                        : 7
};

export {
  GROUP_STATUS
};
